import { BehaviorSubject, distinctUntilChanged } from 'rxjs';
import {
  GojsHtmlInfoContextMenuConfig,
  GojsHtmlInfoContextMenuItem,
  GojsHtmlInfoContextMenuSettings,
  GojsHtmlInfoTooltipConfig,
} from './gojs-html-info.model';

export abstract class GojsHtmlInfoService {
  protected readonly tooltip$$ = new BehaviorSubject<GojsHtmlInfoTooltipConfig>({
    show: false,
    text: '',
  });

  protected readonly contextMenu$$ = new BehaviorSubject<{
    config: GojsHtmlInfoContextMenuConfig;
    menuItems: GojsHtmlInfoContextMenuItem[];
  }>({
    config: { open: false },
    menuItems: [],
  });

  readonly tooltip$ = this.tooltip$$.pipe(distinctUntilChanged());
  readonly contextMenu$ = this.contextMenu$$.pipe(distinctUntilChanged());

  abstract showMenu(settings: GojsHtmlInfoContextMenuSettings): void;

  hideMenu() {
    this.contextMenu$$.next({
      config: { open: false },
      menuItems: [],
    });
  }

  showTooltip(config: GojsHtmlInfoTooltipConfig) {
    this.tooltip$$.next(config);
  }

  hideTooltip() {
    this.tooltip$$.next({ show: false, text: '' });
  }
}
